import { render, staticRenderFns } from "./DamaByNumbers.vue?vue&type=template&id=e04844e6&scoped=true&"
import script from "./DamaByNumbers.vue?vue&type=script&lang=js&"
export * from "./DamaByNumbers.vue?vue&type=script&lang=js&"
import style0 from "./DamaByNumbers.vue?vue&type=style&index=0&id=e04844e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04844e6",
  null
  
)

export default component.exports